import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Checkbox } from '@speeki/global-ui-components';
import { ModalsProvider } from '@speeki/global-ui-components';

import NicoleSignup from '@assets/images/nicole_signup.png';

import { LoginText } from '@components/molecules/LoginText/LoginText';

import { useResponsive } from '@utils/hooks/useResponsive';
import { useTenantByUuid } from '@utils/hooks/useTenantByUuid';

import { AuthService } from '@services/AuthService/AuthService';

import { signUpFormDataVar } from '@boot/reactiveVariables';
import { SignUpFormValues } from '@domains/auth/pages/SignUpPage/SignUpPage';

import {
    ListItem,
    NicoleImage,
    TermsButton,
    TermsInnerWrapper,
    TermsList,
    TermsSectionWrapper,
    TermsText,
} from './TermsSection.styled';

interface TermsSectionProps {}

export const TermsSection = ({}: TermsSectionProps) => {
    const { t } = useTranslation();

    const isMd = useResponsive('md');

    const tenantUuid = AuthService.getTenantUuid();
    const { data: tenentData } = useTenantByUuid({
        skip: !tenantUuid,
        variables: {
            uuid: tenantUuid ?? '',
        },
    });

    const isNicole =
        tenentData?.tenant.assetSettings.nicoleSetting === 'DEFAULT';

    const {
        formState: { errors, isValid },
        handleSubmit,
        register,
    } = useFormContext<SignUpFormValues>();

    const onSubmit = (data: SignUpFormValues) => {
        signUpFormDataVar(data);
        ModalsProvider.open('TermsAndConditionsInfoModal');
    };

    return (
        <TermsSectionWrapper isNicole={isNicole}>
            {!isMd && isNicole && (
                <NicoleImage alt="nicole" src={NicoleSignup} />
            )}
            <TermsInnerWrapper>
                <Checkbox
                    {...register('privacyPolicy')}
                    error={!!errors.privacyPolicy}
                    message={t(errors.privacyPolicy?.message || '')}
                    required
                    testId="YdG584G"
                    textSpacing={28}
                >
                    <TermsText>
                        {t('BEFORE_GETTING_STARTED_INFO_TEXT')}:
                    </TermsText>
                    <TermsList>
                        <li>
                            <ListItem>
                                {t('BEFORE_GETTING_STARTED_INFO_1')};
                            </ListItem>
                        </li>
                        <li>
                            <ListItem>
                                {t('BEFORE_GETTING_STARTED_INFO_2')};
                            </ListItem>
                        </li>
                        <li>
                            <ListItem>
                                {t('BEFORE_GETTING_STARTED_INFO_3')};
                            </ListItem>
                        </li>
                        <li>
                            <ListItem>
                                {t('BEFORE_GETTING_STARTED_INFO_4')}{' '}
                                {t('PRIVACY_POLICY')}.
                            </ListItem>
                        </li>
                    </TermsList>
                </Checkbox>
                <TermsButton
                    disabled={!isValid}
                    onClick={handleSubmit(onSubmit)}
                    testId="button_create-speeki-account"
                    variant={'primary'}
                >
                    {t('CREATE_SPEEKI_ACCOUNT')}
                </TermsButton>
                {!isMd && <LoginText />}
            </TermsInnerWrapper>
        </TermsSectionWrapper>
    );
};
